module.exports = __webpack_public_path__ + "img/paper_plane.2958e403.jpg";